import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { login, resetPassword } from "../services/authService";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n/LanguageContext";

export default function Login() {
  const navigate = useNavigate();
  const { t } = useLang();
  const { profile, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [sendingReset, setSendingReset] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setNotice("");
    try {
      const { profile } = await login(email, password);
      if (profile.role === "admin") navigate("/admin");
      else navigate("/catalog"); // reps + customers land on the catalog
    } catch (err) {
      if (err.message === "PENDING_APPROVAL") {
        setError(t("pendingApproval"));
      } else if (err.message === "ACCOUNT_REJECTED") {
        setError(t("accountRejected"));
      } else {
        setError(t("invalidLogin"));
      }
    }
  }

  async function handleForgotPassword() {
    setError("");
    setNotice("");
    if (!email.trim()) {
      setError(t("typeEmailFirst"));
      return;
    }
    setSendingReset(true);
    try {
      await resetPassword(email.trim());
    } catch {
      // Deliberately ignore errors (e.g. unknown email) — always show the same
      // message so the form can't be used to probe which emails have accounts.
    } finally {
      setSendingReset(false);
      setNotice(t("resetSent", email.trim()));
    }
  }

  // Already signed in? Straight to the catalog — no login page detour.
  if (!loading && profile) return <Navigate to="/catalog" replace />;

  return (
    <div className="auth-page">
      <h2>{t("signInTitle")}</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" placeholder={t("email")} value={email}
          onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder={t("password")} value={password}
          onChange={(e) => setPassword(e.target.value)} required />
        {error && <p className="error">{error}</p>}
        {notice && <p className="auth-notice">{notice}</p>}
        <button type="submit">{t("signIn")}</button>
      </form>
      <button
        type="button"
        className="forgot-password-link"
        disabled={sendingReset}
        onClick={handleForgotPassword}
      >
        {sendingReset ? t("sending") : t("forgotPassword")}
      </button>
      <p><Link to="/register">{t("requestAccess")}</Link></p>
    </div>
  );
}
